export default __webpack_public_path__ + "static/darcy-bdafa88ba16e9c6f70855fbfa0e6aae0.png";